import {
  AccountPage,
  AuthApple,
  AuthKakao,
  AuthNaver,
  ChatPage,
  ChatSettingPage,
  DashboardPage,
  EmailLoginPage,
  InstructorsPage,
  InvitationAcceptPage,
  InvoicePage,
  JoinPage,
  LandingPage,
  LoginPage,
  MembershipProductsPage,
  MembershipUsersPage,
  MySchedulePage,
  NotFoundPage,
  NoticeDetailPage,
  NoticePage,
  PartnerUserPage,
  PhoneLoginPage,
  ProductOrdersPage,
  ProductsPage,
  LastChanceProductsPage,
  ProfileEditPage,
  ProgramAfterCarePage,
  ProgramInvoicePage,
  GroupingPolicySettingsPage,
  ProgramSchedulesPage,
  ReservationSuccessPage,
  RedirectToExternal,
  ReportsPage,
  ReviewsPage,
  SettlementsPage,
  UserContentEditorPage,
  UserContentsPage,
} from '@pages/index';

const routes = [
  { path: '/auth/kakao', element: <AuthKakao /> },
  { path: '/auth/naver', element: <AuthNaver /> },
  { path: '/auth/apple', element: <AuthApple /> },
  { path: '/auth/kakao/:type', element: <AuthKakao /> },
  { path: '/auth/naver/:type', element: <AuthNaver /> },
  { path: '/auth/apple/:type', element: <AuthApple /> },
  { path: '/invite/instructor', element: <InvitationAcceptPage /> },
  { path: '/join', element: <JoinPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/login/phone', element: <PhoneLoginPage /> },
  { path: '/login/email', element: <EmailLoginPage /> },
  { path: '/dashboard', element: <DashboardPage /> },
  { path: '/profile', element: <ProfileEditPage /> },
  { path: '/account', element: <AccountPage /> },
  { path: '/my-schedule', element: <MySchedulePage /> },
  { path: '/partner-crm', element: <PartnerUserPage /> },
  { path: '/instructors', element: <InstructorsPage /> },
  { path: '/reports', element: <ReportsPage /> },
  { path: '/products', element: <ProductsPage /> },
  { path: '/last-chance-products', element: <LastChanceProductsPage /> },
  { path: '/reservation-success', element: <ReservationSuccessPage /> },
  { path: '/product-orders', element: <ProductOrdersPage /> },
  { path: '/program-schedules', element: <ProgramSchedulesPage /> },
  { path: '/grouping-policy-settings', element: <GroupingPolicySettingsPage /> },
  { path: '/program-schedule-groups', element: <ProgramSchedulesPage /> },
  { path: '/platform-orders', element: <RedirectToExternal url="/product-orders" /> },
  { path: '/channel-orders', element: <RedirectToExternal url="/product-orders" /> },
  { path: '/program-invoices', element: <ProgramInvoicePage /> },
  { path: '/settlements', element: <SettlementsPage /> },
  { path: '/program-after-care', element: <ProgramAfterCarePage /> },
  { path: '/invoices', element: <InvoicePage /> },
  { path: '/reviews', element: <ReviewsPage /> },
  { path: '/user-contents', element: <UserContentsPage /> },
  { path: '/user-contents/new', element: <UserContentEditorPage /> },
  { path: '/user-contents/:id/edit', element: <UserContentEditorPage /> },
  { path: '/membership-users', element: <MembershipUsersPage /> },
  { path: '/membership-products', element: <MembershipProductsPage /> },
  { path: '/chat', element: <ChatPage /> },
  { path: '/chat-setting', element: <ChatSettingPage /> },
  { path: '/notice', element: <NoticePage /> },
  { path: '/notice/:noticeId', element: <NoticeDetailPage /> },
  { path: '/', element: <LandingPage /> },
  { path: '*', element: <NotFoundPage /> },
];

export default routes;
